class AboutJs {
  constructor(el, opt) {
    this.el = el;
    this.valueImageSwiperInstance = false;
    this.valueTextSwiperInstance = false;
    if ($("." + this.el).length > 0) {
      this.event();
    }
    const aboutSwiper = document.querySelectorAll('.js-fade-swiper-divider');
    if (aboutSwiper.length > 0) {
      this.fadeSwiper(aboutSwiper);
    }
  }
  event() {

  }
  fadeSwiper(swiperEle) {
    swiperEle.forEach((item) => {
      new Swiper(item, {
        speed: 1500,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: 3000
        }
      })
    })
  }
}

class RecruitJs {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
    // 事業スライダー
    const imageEle = document.querySelector('.js-recruit-business-swiper');
    const textEle = document.querySelector('.js-recruit-business-text-swiper');
    if(imageEle && textEle){
      this.businessSwiper(imageEle,textEle);
    }
  }
  event() {

  }
  businessSwiper(imageEle,textEle) {
    const imageSwiper = new Swiper(imageEle,{
      slidesPerView: 'auto',
      spaceBetween: 20,
      speed: 1000,
      autoplay: {
        delay: 3000
      },
      breakpoints: {
        769: {
          spaceBetween: 60,
        }
      }
    })
    const textSwiper = new Swiper(textEle,{
      slidesPerView: 'auto',
      speed: 1000,
      effect: 'fade',
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true
      },
    })

    imageSwiper.controller.control = textSwiper;
    textSwiper.controller.control = imageSwiper;

    gsap.to({}, {
      scrollTrigger: {
        trigger: imageEle,
        start: 'top bottom',
        onEnter: () => {
          imageSwiper.params.autoplay = {
            delay: 3000,
          };
          imageSwiper.autoplay.start();
        },
      },
    });
  }
  businessTextSwiper(swiperEle) {
  }
}

class TopJs {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector("." + this.el)) {
      this.event();
    }
    if (document.querySelector('.js-mv-swiper')) {
      this.mvSwiper('.js-mv-swiper');
    }
    if (document.querySelector('.js-top-recruit-bg')) {
      this.recruitSwiper();
    }
    if (document.querySelector('.js-top-header')) {
      this.headerAnimation('.js-top-header');
    }
    if (document.querySelector('.js-informationSwiper')) {
      this.informationSwiper('.js-informationSwiper');
    }
  }
  event() {
    this.fvAnimation();
    this.middleAnimation();
  }
  recruitSwiper() {
    if (window.matchMedia('(max-width: 768px)').matches) {
      new Swiper('.js-top-recruit-bg', {
        slidesPerView: 2,
        loop: true,
        speed: 15000,
        direction: 'vertical',
        autoplay: {
          delay: 0,
        }
      })
    } else {
      new Swiper('.js-top-recruit-bg', {
        slidesPerView: 2.2,
        loop: true,
        speed: 15000,
        autoplay: {
          delay: 0,
        }
      })
    }
  }
  headerAnimation(headerEle) {
    // const ele = document.querySelector(headerEle);
    // const logoEle = ele.querySelector('.js-top-header__logo');
    // const navEle = ele.querySelector('.js-top-header__nav');
    // gsap.to(logoEle, {
    //   scrollTrigger: {
    //     trigger: '.js-mv-swiper',
    //     start: 'bottom 100px',
    //     end: 'bottom top',
    //     onEnter: () => {
    //       logoEle.classList.remove('is-active');
    //       navEle.classList.remove('is-active');
    //     },
    //     onEnterBack: () => {
    //       logoEle.classList.add('is-active');
    //       navEle.classList.add('is-active');
    //     }
    //   }
    // })
  }
  informationSwiper(el) {
    if (window.matchMedia('(max-width: 768px)').matches) {
      new Swiper(el, {
        slidesPerView: 1.3,
        centeredSlides: true,
        loop: true,
      })
    }
  }
  fvAnimation() {

    $('body').css({
      'position': 'fixed',
      'top': '0',
    })

    let tl = gsap.timeline();

    tl.to('.js-loading', 0.1, {
      opacity: '1',
    });
    tl.from('.js-loading-txt', 1, {
      opacity: 0,
      ease: "power4.out",
      delay: 0.5,
    });

    tl.to('.js-loading-heartCenter', 0.8, {
      opacity: 0,
      width: '50rem'
    });

    tl.from('.js-loading-heart', 2, {
      opacity: 0,
      rotate: '-10deg',
      scale: '0.7',
      ease: "power4.out",  
    });

    tl.to('.js-loading-txt', 1, {
      color: '#000',
      onComplete: function() {
        $('body').css({'position': 'static'})
        $('.js-mv-hidden').animate({'opacity': '1'}, 800);
      }
    }, '-=1');
  }

  middleAnimation() {
    $('.js-middle-hidden').css({'display': 'none'});

    $('.js-moddle-txt').each(function() {
      const $this = $(this);
  
      // ノードを一つずつ処理
      $this.contents().each(function processNode() {
        if (this.nodeType === Node.TEXT_NODE) {
          // テキストノードの場合、一文字ずつ<span>で囲む
          const text = $(this).text();
          const wrappedText = text.split('').map(char => `<span>${char}</span>`).join('');
          $(this).replaceWith(wrappedText);
        } else if (this.nodeType === Node.ELEMENT_NODE) {
          // 子要素を再帰的に処理
          $(this).contents().each(processNode);
        }
      });
    });

    let flag = false;

    let trigger = ScrollTrigger.create({
      trigger: ".js-middle-trigger",
      start:"center-=10px center",
      onEnter: () => {
        if (!flag) {
          $('.js-loading').css({'display': 'none'});
          flag = true;
          trigger.kill(); // トリガーを削除
        }

        let tl = gsap.timeline();
    
        tl.to('.js-line', 5, {
          'stroke-dashoffset': 1500,
        });
    
        tl.from('.js-moddle-txt span', 0.3, {
          opacity: 0,
          duration: 0,
          stagger: 0.05,
          onStart: () => {
            $('.js-moddle-txt').css({'opacity': '1'});
          }
        }, '<');
    
        tl.to('.js-moddle-svg svg:last-of-type, .js-moddle-btn', 0.8, {
          opacity: 1,
          onComplete: function() {
            // $('.js-loading').css({'display': 'block'});
            $('.js-moddle-anime').css({'opacity': '0'});
            $('.js-middle-hidden').css({'display': 'block'});
            $('html, body').scrollTop($('.js-middle').offset().top);
    
            gsap.to('.js-moddle-svg', {
              scrollTrigger: {
                pin: true, //トリガー要素を固定する
                trigger: ".js-middle",
                start:"center center",
                end:"center+=12500px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-moddle-scale', {
              scale: 22,
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center center",
                end:"center+=4000px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-moddle-opacity', {
              opacity: 0,
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center center",
                end:"center+=4000px center",
                scrub: 1,
              }
            });
            
            gsap.to('.js-moddle-txt, .js-moddle-btn', {
              opacity: 0,
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=3500px center",
                end:"center+=4000px center",
                scrub: 1,
                onLeave : () => {
                  $('.js-moddle-bg').css({'pointer-events': 'none'});
                },
                onEnterBack : () => {
                  $('.js-moddle-bg').css({'pointer-events': 'auto'});
                }
              }
            });
    
            gsap.to('.js-seek-bar', {
              opacity: '1',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=3500px center",
                end:"center+=4000px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-middle-elA', {
              opacity: 1,
              top: '50%',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=4000px center",
                end:"center+=4500px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-middle-elA > div', {
              opacity: 0,
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=5500px center",
                end:"center+=6000px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-seek-bar .a', {
              height: '100%',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=4000px center",
                end:"center+=6000px center",
                scrub: 1,
              }
            });

            gsap.to('.js-middle-imgA', {
              scale: '1.1',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=4000px center",
                end:"center+=6000px center",
                scrub: 1,
                onLeave : () => {
                  $('.js-middle-imgB').animate({'height': '100%'}, 800);
                  $('.js-seek-bar .a').animate({'opacity': '0'}, 800);
                  $('.js-middle-elA').css({'pointer-events': 'none'});
                  $('.js-middle-elB').css({'pointer-events': 'auto'});
                },
                onEnterBack : () => {
                  $('.js-middle-imgB').animate({'height': '0%'}, 800);
                  $('.js-seek-bar .a').animate({'opacity': '1'}, 800);
                  $('.js-middle-elA').css({'pointer-events': 'auto'});
                  $('.js-middle-elB').css({'pointer-events': 'none'});
                }
              }
            });
    
            gsap.to('.js-middle-elB', {
              opacity: 1,
              top: '50%',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=7000px center",
                end:"center+=7500px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-middle-elB > div', {
              opacity: 0,
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=8500px center",
                end:"center+=9000px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-seek-bar .b', {
              height: '100%',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=7000px center",
                end:"center+=9000px center",
                scrub: 1,
              }
            });

            gsap.to('.js-middle-imgB', {
              scale: '1.1',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=7000px center",
                end:"center+=9000px center",
                scrub: 1,
                onLeave : () => {
                  $('.js-middle-imgC').animate({'height': '100%'}, 800);
                  $('.js-seek-bar .b').animate({'opacity': '0'}, 800);
                  $('.js-middle-elB').css({'pointer-events': 'none'});
                  $('.js-middle-elC').css({'pointer-events': 'auto'});
                },
                onEnterBack : () => {
                  $('.js-middle-imgC').animate({'height': '0%'}, 800);
                  $('.js-seek-bar .b').animate({'opacity': '1'} , 800);
                  $('.js-middle-elB').css({'pointer-events': 'auto'});
                  $('.js-middle-elC').css({'pointer-events': 'none'});
                }
              }
            });
    
            gsap.to('.js-middle-elC', {
              opacity: 1,
              top: '50%',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=10000px center",
                end:"center+=10500px center",
                scrub: 1,
              }
            });
    
            gsap.to('.js-seek-bar .c', {
              height: '100%',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=10000px center",
                end:"center+=12000px center",
                scrub: 1,
              }
            });

            gsap.to('.js-middle-imgC', {
              scale: '1.1',
              scrollTrigger: {
                trigger: ".js-middle-trigger",
                start:"center+=10000px center",
                end:"center+=12000px center",
                scrub: 1,
              }
            });
          }
        });
      }
    })
    
  }
}

class AjaxMoreInfo {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector("." + this.el)) {
      this.event();
    }
  }
  event() {
    const moreBtn = document.querySelector("." + this.el+'__btn');
    const moreArea = document.querySelector("." + this.el);
    if (moreBtn) {
      moreBtn.addEventListener('click', () => {
        const page = parseInt(moreBtn.getAttribute('data-page'), 10);
        const postNum = parseInt(moreBtn.getAttribute('data-post-num'), 10);
        const ajaxUrl = moreBtn.getAttribute('data-url');
        const tax = moreBtn.dataset.tax;
        const term = moreBtn.dataset.term;

        let fetchUrl = `${ajaxUrl}?action=load_more_posts&page=${page}&postnum=${postNum}`;

        if (tax && term) {
          fetchUrl += `&tax=${encodeURIComponent(tax)}&term=${encodeURIComponent(term)}`;
        }

        fetch(fetchUrl)
          .then(response => response.json())
          .then(data => {
            console.log(data)
            if (data.success) {
              moreArea.insertAdjacentHTML('beforeend', data.data.content);
              moreBtn.setAttribute('data-page', page + 1);

              if (!data.data.has_more) {
                moreBtn.style.display = 'none';
              }
            } else {
              console.error(data.message);
            }
          })
          .catch(error => console.error('AJAX error:', error));
    });
  }
  }
}

class AlpineStore {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    // スマホ判別
    Alpine.store('isMobile', window.innerWidth <= 768);

    function checkScreenSize() {
      Alpine.store('isMobile', window.innerWidth <= 768);
    }

    window.addEventListener('resize', checkScreenSize);

    // 事業所検索
    Alpine.store('mapArea', {
      selectedArea: 29,
    });
  }
}

class ContactAccept {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const dataAccept = document.querySelector('[data-accept]').dataset.accept;
    const acceptEle = document.querySelector('.js-acceptance');
    acceptEle.querySelector('a').href = dataAccept;
  }
}

class ContactSelect {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const selectEle = document.querySelectorAll('.js-select select');
    selectEle.forEach((item, key) => {
      item.addEventListener('change', (event) => {
        console.log(event);
        const selectVal = event.target.value;
        if (selectVal) {
          event.target.style.color = 'rgba(23,23,23,1)';
        } else {
          event.target.style.color = 'rgba(23, 23, 23, 0.4)';
        }
      })
    })
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class CustomScrollContent {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector("." + this.el)) {
      this.event();
    }
  }
  event() {
    const contentWraps = document.querySelectorAll("." + this.el);
    contentWraps.forEach((ele) => {
      const seekBar = ele.querySelector("." + this.el + "__seek-bar");
      const content = ele.querySelector("." + this.el + "__scroll-area");
      const contentHeight = content.scrollHeight;
      const containerHeight = ele.offsetHeight;

      // シークバーのスクロールイベント
      content.addEventListener("scroll", () => {
        const scrollRatio = content.scrollTop / (contentHeight - containerHeight);
        gsap.to(seekBar, {
          height: `${scrollRatio * 100}%`,
          duration: 0.3,
          ease: "power1.out",
        });
      });

      // ドラッグでスクロール
      let isDragging = false;
      let startY = 0;
      let startScrollTop = 0;

      seekBar.addEventListener("mousedown", (e) => {
        isDragging = true;
        startY = e.clientY;
        startScrollTop = content.scrollTop;
        document.body.style.userSelect = "none"; // 選択を防止
      });

      document.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        const deltaY = e.clientY - startY;
        const scrollRatio = deltaY / containerHeight;
        content.scrollTop = startScrollTop + scrollRatio * contentHeight;
      });

      document.addEventListener("mouseup", () => {
        isDragging = false;
        document.body.style.userSelect = ""; // 選択を復帰
      });
    });
  }
}

class FacilityInfo {
  constructor(el, opt) {
    this.el = el;
    if (document.querySelector("." + this.el)) {
      this.event();
    }
  }
  event() {
    const infoWrap = document.querySelector("." + this.el);
    gsap.to(infoWrap,{
      opacity: 0,
      scrollTrigger: {
        trigger: 'footer',
        start: 'top bottom',
        end: 'top 95%',
        scrub: 1,
        onEnter: () => {
          infoWrap.style.pointerEvents = 'none'
        },
        onEnterBack: () => {
          infoWrap.style.pointerEvents = 'auto'
        }
      },
    })
  }
}

class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class ImgParallax {
  constructor(el, opt) {
    this.el = el;
    const elements = document.querySelectorAll("." + this.el);
    if (elements.length > 0) {
      this.event(elements);
    }
  }

  event(elements) {
    // batch() を使って複数の要素を一括で処理
    ScrollTrigger.batch(elements, {
      onEnter: batch => {
        batch.forEach((ele, index) => {
          const scrub = ele.dataset.scrub ? ele.dataset.scrub : 3;

          const wrapperHeight = ele.getBoundingClientRect().height;
          const imgHeight = ele.querySelector('img').getBoundingClientRect().height;
          const moveTop = Math.min(0, wrapperHeight - imgHeight); // 0以下にならないように調整

          gsap.to(ele.querySelector('img'), {
            y: moveTop,
            scrollTrigger: {
              trigger: ele, // 要素そのものを指定
              start: 'top bottom',
              end: 'bottom top',
              scrub: scrub,
            }
          });
        });
      },
      start: "top bottom", // トリガー位置を指定
      end: "bottom top",   // トリガー終了位置を指定
      scrub: true          // スクロール連動で動かす
    });
  }
}

let lenis;

class InertiaScroll {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){

    if (window.matchMedia('(min-width: 769px)').matches) {
      lenis = new Lenis({
        lerp: 2, // 慣性の強さ
        duration: 0.8, // スクロールアニメーションの時間
      });

      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      
      requestAnimationFrame(raf);
    }
  }
}

class InviewEvent {
  constructor(el, opt) {
    $('.js-load-inview').animate({ 'opacity': '1' });
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if ($(this.el).length > 0) {
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if (entry.intersectionRatio >= 0.05) {
          item.classList.add('is-inview');
          if (item.classList.contains('js-inview-each')) {
            this.inviewEachUp(item);
          }
          if (item.classList.contains('js-inview-lottie')) {
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if (entry.intersectionRatio >= 0.9) {
          item.classList.add('is-inview');
          if (item.classList.contains('js-inview-each')) {
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e) => {
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e) => {
      observerAll.observe(e);
    });
  }
  inviewEachUp(item) {
    $(item).find(this.eachItem).each((i, el) => {
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: () => {
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i, el) => {
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: () => {
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i, el) => {
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: () => {
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item) {
    if ($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if ($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if ($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if ($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if ($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if ($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if ($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if ($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class LenisExclude {
  constructor(el,opt){
    this.el = el;
    if(document.querySelector(el)){
      this.event(el);
    }
  }
  event(el){
    const excludeEles = document.querySelectorAll(el);
    excludeEles.forEach(excludeEle => {
      excludeEle.addEventListener('wheel',(e)=>{
        e.stopPropagation();
      })
    });
  }
}

class Loading {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
  }
}

class RecruitButton {
  constructor(){
    const recruitButton = document.querySelector('.js-recruit-button');
    if(recruitButton){
      this.event(recruitButton);
    }
  }
  event(recruitButton) {
    gsap.to(recruitButton,{
      opacity: 0,
      pointerEvents: 'none',
      scrollTrigger: {
        trigger: '.js-footer',
        start: 'top bottom',
        end: 'top 80%',
        scrub: true
      }
    })
  }
}
// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}

(() => {

})();

//DOMContentLoaded
$(() => {
});

//after loading animation
$(window).on('load', () => {
  let inertiaScroll = new InertiaScroll();
  new LenisExclude('.js-lenis-exclude');
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let formConvert = new FormConvert('js-convert');
  let contactSelect = new ContactSelect('js-select');
  let contactAccept = new ContactAccept('js-acceptance');
  
  new CustomScrollContent('js-custom-scroll-content');
  new FacilityInfo('js-facility-info');
  new AjaxMoreInfo('js-ajax-more-info');
  new RecruitButton();

  // pages
  let topJs = new TopJs('js-top')
  let recruitJs = new RecruitJs('js-recruit')
  let aboutJs = new AboutJs('js-about')
});

document.addEventListener('alpine:init', () => {
  new AlpineStore();
})